import WorkOrderDetail from './WorkOrderDetail';

export default WorkOrderDetail;
